import { supabase } from '../supabase';

// Llama a /api/google-calendar con el JWT de la sesion actual.
// action: 'status' | 'connect' | 'sync' | 'disconnect'
export async function llamarGoogleCalendar(action, extra = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Sin sesión activa');
  const res = await fetch('/api/google-calendar', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ action, ...extra }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
  return data;
}

// Evento de ventana para avisarle al sincronizador automatico que el estado
// de la conexion cambio (se vinculo o desvinculo desde Configuracion).
export const EVENTO_GCAL = 'gcal-status';
export function avisarEstadoGoogleCalendar(connected) {
  window.dispatchEvent(new CustomEvent(EVENTO_GCAL, { detail: { connected } }));
}
